import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState, useRef } from "react";
import { Button, Container, Image } from "react-bootstrap";
import ans from "./editanswer.module.css";
import { useNavigate } from "react-router-dom";
import { useCookies } from "../../../../hooks/useCookies";
import Sidebar from "../../../userflow/components/sidebar/sidebar";
import answer from "../../../../assets/images/answer.png";
import { useAlert } from "../../../../Context/AlertModalContext";
import { questionsDefaultAnswers } from "../../../../utils/constants";
import QuestionPrompt from "./QuestionPrompt/index.jsx";
import AlertModal from "./AlertModal/index.jsx";
import * as profileActions from "../../../../actions/Profile.jsx";
import { useProfile } from "../../../../components/userflow/components/context/ProfileContext.jsx";
import { useQuestion } from "../../../../Context/QuentionContext.jsx";

export default function UpdateAnswers() {
  const [show, setShow] = useState(false);
  const [count, setCount] = useState(0);
  const [updatecount, setUpdatecount] = useState(0);
  const [modalData, setModalData] = useState({});
  const { getCookie } = useCookies();
  const [questions, setQuestions] = useState([]);
  const navigate = useNavigate();
  const [alert, setAlert] = useState(false);
  const alertmodal = useAlert();
  const approvalstatus = getCookie("approval");
  const token = getCookie("token");
  const [localAnswers, setLocalAnswers] = useState({});
  const [deletedAnswers, setDeletedAnswers] = useState(new Set());
  const hasFetchedRef = useRef(false);
  const { updateProfile } = useProfile();
  const { updateQuestion, fetchUpdatedData } = useQuestion();
  const [refresh, setRefresh] = useState(false);

  const Totalcount = count + updatecount;

  const fetchQuestionsList = async () => {
    try {
      const response = await profileActions.questionAnswersList();
      if (!response) throw new Error("Failed to fetch questions");
      const data = await response;
      setQuestions(data.questions);
    } catch (error) {
      console.error(error);
    }
  };
  const fetchCounts = async () => {
    try {
      const response = await profileActions.getQuestionsCount();
      if (!response) throw new Error("Failed to fetch counts");
      const data = await response;
      setCount(data.count);
    } catch (error) {
      console.error(error);
    }
  };
  const fetchUpdateCount = async () => {
    try {
      const response = await profileActions.getUpdateQuestionsCount();
      if (!response) throw new Error("Failed to fetch update count");
      const data = await response;
      setUpdatecount(data.count);
    } catch (error) {
      console.error("Error fetching update count:", error);
    }
  };

  useEffect(() => {
    if (!token) return;
    fetchCounts();
    fetchQuestionsList();
    fetchUpdateCount();
  }, [token, refresh]);

  const handleDeleteAnswer = questionId => {
    setLocalAnswers(prev => ({ ...prev, [questionId]: "" }));
    setDeletedAnswers(prev => new Set(prev).add(questionId));

    setQuestions(prevQuestions =>
      prevQuestions?.map(q =>
        q.question_id === questionId ? { ...q, answer: "" } : q
      )
    );
  };

  const handleAnswerSave = (questionId, newAnswer) => {
    setQuestions(prevQuestions =>
      prevQuestions.map(q =>
        q.question_id === questionId ? { ...q, answer: newAnswer } : q
      )
    );
    setLocalAnswers(prev => {
      return { ...prev, [questionId]: newAnswer };
    });
  };

  // Save all local answers by calling API on Save button click
const handleSaveUpdates = async () => {
  try {
    const updates = [];
    let finalAnswersCount = 0;

    questions.forEach(q => {
      const questionId = q.question_id;
      const originalAnswer = q.answer || "";
      const hasLocalAnswer = localAnswers.hasOwnProperty(questionId);
      const newAnswer = localAnswers[questionId];

      if (approvalstatus === "APPROVED") {
        if (hasLocalAnswer) {
          if (newAnswer) {
            updates.push({ question_id: questionId, answer: newAnswer });
            finalAnswersCount++;
          } else if (originalAnswer || deletedAnswers.has(questionId)) {
            updates.push({ question_id: questionId }); // mark for deletion
          }
        } else if (originalAnswer) {
          finalAnswersCount++;
        }
      } else {
        if (originalAnswer) {
          updates.push({ question_id: questionId, answer: originalAnswer });
          finalAnswersCount++;
        }
        if (hasLocalAnswer && newAnswer) {
          const alreadyIncluded = updates.find(u => u.question_id === questionId);
          if (!alreadyIncluded) {
            updates.push({ question_id: questionId, answer: newAnswer });
            finalAnswersCount++;
          }
        }
      }
    });

    Object.entries(localAnswers).forEach(([questionId, newAnswer]) => {
      const id = Number(questionId);
      const isNewQuestion = !questions.find(q => q.question_id === id);
      if (isNewQuestion && newAnswer) {
        updates.push({ question_id: id, answer: newAnswer });
        finalAnswersCount++;
      }
    });

    // 3. Validate exactly 2 answers
    if (finalAnswersCount !== 2) {
      alertmodal.setModal({
        show: true,
        title: "Validation Error",
        message: `Only 2 prompts can be answered. Currently you have ${finalAnswersCount}.`,
      });
      return;
    }

    if (updates.length > 0) {
      const payload = { update: updates };
      const response = approvalstatus === "APPROVED"
        ? await profileActions.updateQuestionAnswerRequest(payload)
        : await profileActions.updateQuestionAnswer(payload);

      if (response) {
        setLocalAnswers({});
        setDeletedAnswers(new Set());
        setRefresh(true);
        await fetchQuestionsList();
        await updateProfile("update");
        await fetchUpdatedData();
        if( approvalstatus !== "APPROVED"){
         
            navigate("/updateprofile");
        }
      }
    } else {
      navigate("/updateprofile");
    }
  } catch (error) {
    console.error("Error saving answers:", error);
  }
};



  useEffect(() => {
    if (hasFetchedRef.current) return;

    if (updateQuestion !== undefined) {
      if (updateQuestion?.length > 0) {
        hasFetchedRef.current = true;

        alertmodal.setModal({
          show: true,
          message:
            " Please note that changes to your written prompts will be reviewed by our admin team before going live. This process may take up to 48 hours.",
          title: "",
          onButtonClick: () => {
            navigate("/updateprofile");
          },
        });
      }
    }
  }, [updateQuestion, approvalstatus, alertmodal, navigate]);
  const refreshpage = () => {
    setRefresh(!refresh);
  };
  return (
    <Sidebar>
      <div className={ans.profile_ques}>
        <div className={ans.jobcontainer}>
          <QuestionPrompt
            show={show}
            alertmodal={alertmodal}
            count={count}
            onHide={() => setShow(false)}
            modalData={modalData}
            className="customer-modal-without-header-footer"
          />
          <AlertModal
            show={alert}
            updatecount={updatecount}
            alertmodal={alertmodal}
            count={count}
            onHide={() => setAlert(false)}
          />

          <div className={ans.jobmain}>
            <div className={ans.jobcontent}>
              <div className={ans.jobdetails}>
                <div className={ans.yourjob}>
                  <Container className="job-text">
                    <Image width="40px" height="40px" src={answer} />
                    <p>Update: Write your profile answers</p>
                  </Container>
                  <p
                    style={{
                      color: "#4E1173",
                      fontSize: "14px",
                      lineHeight: "20px",
                      textAlign: "center",
                      fontWeight: "600",
                    }}
                  >
                    2 prompts are required, but you can add more.
                  </p>
                  <div
                    style={{
                      maxHeight: "60vh",
                      overflow: "auto",
                      paddingRight: "5px",
                      scrollBehavior: "smooth",
                      scrollbarWidth: "none",
                      overflowY: "auto",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "1rem",
                        overflowY: "auto",
                      }}
                    >
                      {questions?.map((question, index) => (
                        <div
                          tabIndex={0}
                          key={index}
                          style={{
                            border: question.answer
                              ? "2px solid #F76A7B"
                              : "2px solid #cbcbcb",
                            padding: "1rem",
                            borderRadius: "10px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",

                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setShow(true);
                            setModalData({
                              heading: question.question,
                              placeholder: questionsDefaultAnswers[index],
                              answer: question?.answer,
                              questionId: question.question_id,
                              onAnswerSaved: handleAnswerSave,
                              refreshpage: refreshpage,
                            });
                          }}
                        >
                          <div>
                            <div
                              style={{
                                color: "black",
                                fontSize: "16px",
                                lineHeight: "24px",
                                fontWeight: "600",
                              }}
                            >
                              {question.question}
                            </div>
                            <div
                              style={{
                                color: "#6C6C6C",
                                fontSize: "14px",
                                lineHeight: "20px",
                                fontWeight: "400",
                              }}
                            >
                              {question.answer
                                ? question.answer?.substring(0, 100) + "..."
                                : questionsDefaultAnswers[index]?.substring(
                                    0,
                                    30
                                  ) + "..."}
                            </div>
                          </div>

                          <div
                            style={{
                              marginTop: "3px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              gap: "30px",
                            }}
                          >
                            {question?.answer && (
                              <div
                                onClick={e => {
                                  e.stopPropagation();
                                  e.nativeEvent.stopImmediatePropagation();
                                  handleDeleteAnswer(question.question_id);
                                }}
                              >
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M15 1L1 15M1.00001 1L15 15"
                                    stroke="#424242"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>
                            )}

                            <svg
                              width="22"
                              height="22"
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{
                                pointerEvents:
                                  updateQuestion?.length > 0 ? "none" : "auto",
                                opacity: updateQuestion?.length > 0 ? 0.5 : 1,
                                cursor:
                                  updateQuestion?.length > 0
                                    ? "not-allowed"
                                    : "pointer",
                              }}
                            >
                              <path
                                d="M12.8346 5.5L7.33464 11V14.6667H11.0013L16.5013 9.16667M12.8346 5.5L15.5846 2.75L19.2513 6.41667L16.5013 9.16667M12.8346 5.5L16.5013 9.16667M9.16797 3.66667L3.66797 3.66667L3.66797 18.3333L18.3346 18.3333V12.8333"
                                stroke="url(#paint0_linear_778_6844)"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <defs>
                                <linearGradient
                                  id="paint0_linear_778_6844"
                                  x1="12.0869"
                                  y1="2.10069"
                                  x2="12.0869"
                                  y2="19.9566"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stopColor="#FC8C66" />
                                  <stop offset="1" stopColor="#F76A7B" />
                                </linearGradient>
                              </defs>
                            </svg>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  position: "absolute",
                  display: "flex",
                  alignItems: "left",
                  justifyContent: "center",
                  gap: "30px",
                  bottom: "38px",
                }}
              >
                <Button
                  type="button"
                  className={ans.jobnxtbtn}
                  onClick={() => {
                    if (count === 2 || updatecount === 2 || Totalcount === 2) {
                      navigate("/updateprofile");
                    } else {
                      setAlert(true);
                    }
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  type="button"
                  className={ans.jobnxtbtn2}
                  onClick={handleSaveUpdates}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Sidebar>
  );
}
